import { render } from "./Delegations.vue?vue&type=template&id=7e14c9e9"
import script from "./Delegations.vue?vue&type=script&lang=js"
export * from "./Delegations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__